import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IMpxRepository } from '../../repositories/interfaces/IMpxRepository';
import { IChannelListByCategoryResponse } from '../../../entity/interface/iChannelListByCategoryResponse';

export interface IGetChannelListByCategoryUseCase {
    execute(category: string): Promise<IChannelListByCategoryResponse>;
}

export class GetChannelListByCategoryUseCase implements IGetChannelListByCategoryUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get mpxRepository(): IMpxRepository {
        return container.resolve<IMpxRepository>(DI.REPOSITORIES.IMpxRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(category: string): Promise<IChannelListByCategoryResponse> {
        return this.mpxRepository.getChannelListByCategory(category);
    }
}
